import React, { useState } from 'react';
import '../styles/robotservices.css'
import AnimatedArrowButton from './AnimatedArrowButton';
import AnimationBox from '../animationBox';
import icon1 from '../assets/s1.png'
import icon2 from '../assets/s2.png'
import icon3 from '../assets/s3.png'


const RobotServices = () => {


    return(<div className='robot-services'>
        <AnimationBox>
            <div className='services-inner'>
                <div className='services-box1'>
                    <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'33%',gap:'10px'}}>
                        <div className='services-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <h4>Services Robot</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Automate routine tasks in logistics, healthcare, and hospitality with our adaptable, autonomous service robots.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'33%',gap:'10px'}}>
                        <div className='services-icon'>
                            <img src={icon2} width='35px' height='35px' ></img>
                        </div>
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <h4>System Integration</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Seamlessly integrate robotic solutions into your existing infrastructure, ensuring compatibility and efficiency.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'25px', height:'33%',gap:'10px'}}>
                        <div className='services-icon'>
                            <img src={icon3} width='35px' height='35px' ></img>
                        </div>
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <h4>AI-Driven Automation</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Leverage artificial intelligence to enable intelligent decision-making and adaptive processes for your operations.</p>
                        </div>
                    </div>

                </div>
                <div className='services-box2'>
                <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'15%',gap:'10px'}}>
                        
                            <h4 style={{color:'#FFD52B'}}>Solution Overview</h4>
                            
                </div>
                    <div className='myservices' style={{display:'flex',padding:'25px', height:'85%',gap:'10px',paddingTop:"60px"}}>
                        
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <h1 style={{fontWeight:"600"}}>Comprehensive<br></br> Automation Solutions</h1>
                            <p style={{color:'white', fontSize:"14px"}}>From service robots to advanced system integration, our solutions are designed to enhance productivity, streamline operations, and empower industries with cutting-edge technology.</p>
                            <AnimatedArrowButton text="Learn More" link="/Robotics-Services"   />
                        </div>
                    </div>

                </div>

            </div>
        </AnimationBox>
    
    </div>);


}

export default RobotServices ;